import ManageDealStatusButton from './ManageDealStatusButton.component';

export default ManageDealStatusButton;
